(() => {
  function mount(root = document) {
    root.querySelectorAll('[data-tro-video]').forEach(video => {
      if (video.dataset.initialized) return;
      video.dataset.initialized = 'true';
      const shell = video.closest('.tro-video-shell');
      const button = shell.querySelector('[data-video-toggle]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      const constrained = () => motion.matches || connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '') || matchMedia('(max-width: 749px)').matches;
      let userPaused = false;
      let inView = false;
      const sync = () => {
        const playing = !video.paused;
        shell.dataset.playing = String(playing);
        button.textContent = playing ? button.dataset.pause : button.dataset.play;
        button.setAttribute('aria-pressed', String(playing));
      };
      const play = async () => {
        if (!video.dataset.loaded) {
          video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
          video.dataset.loaded = 'true';
          video.load();
        }
        try { await video.play(); } catch { video.pause(); }
        sync();
      };
      button.hidden = false;
      button.addEventListener('click', () => {
        if (video.paused) { userPaused = false; play(); }
        else { userPaused = true; video.pause(); }
      });
      video.addEventListener('playing', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('error', sync);
      const reconcile = () => {
        if (!inView || document.hidden || constrained() || userPaused) video.pause();
        else play();
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; reconcile(); }, { threshold: .2 });
        observer.observe(video);
      }
      document.addEventListener('visibilitychange', reconcile);
      motion.addEventListener('change', reconcile);
      sync();
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
